/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseAdminResponseModel } from '../../models/purchase-admin-response-model';

export interface GetPurchaseById$Params {
  purchaseId: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getPurchaseById(http: HttpClient, rootUrl: string, params: GetPurchaseById$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseAdminResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getPurchaseById.PATH, 'get');
  if (params) {
    rb.path('purchaseId', params.purchaseId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseAdminResponseModel>;
    })
  );
}

getPurchaseById.PATH = '/purchases/{purchaseId}';
